export default __webpack_public_path__ + "static/media/maestro.d52205e3.svg";